import { css } from "lit";

export const styles = css`
  :host {
    display: block;
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: var(--sds-size-space-800);
    padding: 48px;
  }

  .icon-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    border: none;
    background: var(--sds-color-white-200);
    color: var(--sds-color-background-warning-default);
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  .icon-button:hover {
    background: var(--sds-color-background-neutral-secondary-hover);
  }

  ::slotted([slot="icon"]) {
    color: inherit;
  }

  .text-content {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
  }

  h2 {
    margin: 0;
    color: var(--sds-color-text-default-primary);
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-05) var(--sds-typography-family-title);
    line-height: 120%;
  }

  p {
    margin: 0;
    color: var(--sds-color-text-default-secondary);
    font: var(--sds-typography-weight-light) var(--sds-typography-scale-03) var(--sds-typography-family-body);
    line-height: 120%;
    max-width: 400px;
  }

  @media (max-width: 768px) {
    .empty-state {
      padding: 48px 24px;
    }
  }
`;
